// LocalesConfig.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { get } from '../services/apiService';


const savedLanguage = sessionStorage.getItem('preferredLanguage') || 'en';

const onLoading = () => {

}
const loadTranslations = async () => {
  const transRes = await get('localization',{}, onLoading);
  console.log('transRes--------->', transRes);
  const resources = {
    en: { translation: transRes?.data?.en },
    ar: { translation: transRes?.data?.ar },
  };
  console.log('resources', resources);
  return resources;
};

export const initI18n = async () => {
  const resources = await loadTranslations();

  await i18n
    .use(initReactI18next)
    .init({
      fallbackLng: 'en',
      debug: false,
      lng: savedLanguage,
      interpolation: {
        escapeValue: false,
      },
      resources,
      react: {
        useSuspense: false,
      },
    });
};

// ✅ export i18n instance to use `i18n.changeLanguage(...)` elsewhere
export default i18n;
